var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "18px",
    viewBox: "0 0 14 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.1-chats-empty",
    transform: "translate(-41.000000, -458.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component/Navigation/Left-Bar-Expanded"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nav/Menu/List--Copy-4",
    transform: "translate(41.000000, 335.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-dashboard",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C13.1045695,0 14,0.8954305 14,2 L14,18 L7,15 L0,18 L0,2 C0,0.89 0.9,0 2,0 L12,0 M6,11 L12.25,4.76 L10.84,3.34 L6,8.18 L3.41,5.59 L2,7 L6,11 Z",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarks);
export default __webpack_public_path__ + "static/media/bookmarks.ba8b08284fa4a2b9a67490b0775ded62.svg";
export { ForwardRef as ReactComponent };